import { SeymourHouseTheme as SeymourHouseMFTheme } from '@famly/mf_theme';
import { hexToRGBA } from 'web-app/util/hex-to-rgb';
import BaseTheme from './base';
const SeymourHousePrimaryColor = '#72226D';
const SeymourHousePrimary = SeymourHousePrimaryColor;
const SeymourHouseActive = hexToRGBA(SeymourHousePrimaryColor, 0.8);
const SeymourHouseBackgroundHover = hexToRGBA(SeymourHousePrimaryColor, 0.04);
const SeymourHouseTheme = {
    ...BaseTheme,
    title: 'Seymour House',
    chromeColor: SeymourHouseMFTheme.colorPalette.brandColor,
    primary: SeymourHousePrimary,
    active: SeymourHouseActive,
    backgroundHover: SeymourHouseBackgroundHover,
    mf: SeymourHouseMFTheme,
};
export default SeymourHouseTheme;
